import { interceptor } from "../utils/interceptor";
import { useDispatch } from "react-redux";
import { showAlert } from "../redux/actions";
import { useState, useCallback } from "react";

const axiosInstance = interceptor();

const useGet = ({ endpoint }) => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(false);

  const dispatch = useDispatch();

  const getData = useCallback(
    async (params) => {
      try {
        setLoading(true);
        let apiEndpoint = endpoint;
        if (params && params.length > 0) {
          const queryString = params
            .map((param) => `${param.key}=${param.val}`)
            .join("&");
          apiEndpoint = `${endpoint}?${queryString}`;
        }

        const result = await axiosInstance.get(apiEndpoint);
        if (result) {
          const apiData = result.data.data;
          setData(apiData);
          return apiData;
        }
      } catch (e) {
        dispatch(
          showAlert({
            show: true,
            type: "danger",
            msg: e?.response?.data?.data?.error,
          })
        );
      } finally {
        setLoading(false);
      }
    },
    [endpoint, dispatch]
  );

  return {
    callApi: getData,
    isLoading,
    data,
  };
};

export default useGet;
